import { render } from "./TableRegion.vue?vue&type=template&id=0c5b4388"
import script from "./TableRegion.vue?vue&type=script&lang=js"
export * from "./TableRegion.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__